export const iconFontAwesomeHandsHandFist = (
	<i className="fa-solid fa-hand-fist"></i>
);
